// extracted by mini-css-extract-plugin
export default {"FieldBoxReadOnly":"ReadOnlyField_FieldBoxReadOnly__kWfe2"};